import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AppsIcon from '@mui/icons-material/Apps';

type PropTypes = {
  handleShowStatsChange: (event: any, value: 'scorecard' | 'stats') => void;
  toggleQuestionsStats: 'scorecard' | 'stats';
};
export const ToggleStats = ({
  handleShowStatsChange,
  toggleQuestionsStats,
}: PropTypes) => {
  return (
    <Box sx={{ backgroundColor: 'rgba(32,33,35,1)', borderRadius: 1 }}>
      <ToggleButtonGroup
        color="primary"
        value={toggleQuestionsStats}
        exclusive
        onChange={handleShowStatsChange}
      >
        <ToggleButton
          value="scorecard"
          fullWidth
          sx={{
            border: 'none',
            width: 140,
            borderRadius: '8px 8px 8px 8px !important',
            ':hover': {
              borderRadius: '8px 0px 0px 8px !important',
            },
          }}
        >
          <FormatListBulletedIcon style={{ marginRight: 8 }} />
          Scorecard
        </ToggleButton>
        <ToggleButton
          value="stats"
          fullWidth
          sx={{
            border: 'none',
            width: 140,
            borderRadius: '8px 8px 8px 8px !important',
            ':hover': {
              borderRadius: '0px 8px 8px 0px !important',
            },
          }}
        >
          <AppsIcon style={{ marginRight: 8 }} />
          Stats
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
